import React from 'react'
import { Link, useStaticQuery, graphql } from 'gatsby'

const RelatedServices = ({ slug }) => {
  const { services } = useStaticQuery(
    graphql`
      query {
        services: allContentfulServices(limit: 4) {
          edges {
            node {
              slug
              title
              icon
              excerpt {
                excerpt
              }
            }
          }
        }
      }
    `
  )

  if (services) {
    return (
      <section className="services-area pt-100 pb-70 bg-f1f8fb">
        <div className="container">
          <div className="section-title">
            <h2>More Services You Might Like</h2>
          </div>

          <div className="row">
            {services.edges
              .filter((item) => {
                return item.node.slug !== slug
              })
              .map((service, index) => {
                if (index <= 2) {
                  const cls =
                    index === 2
                      ? 'col-lg-4 col-sm-6 offset-lg-0 offset-sm-3'
                      : 'col-lg-4 col-sm-6'
                  return (
                    <div key={index} className={cls}>
                      <div className="single-services-box">
                        <div className="icon">
                          <i className={service.node.icon}></i>
                        </div>
                        <h3>
                          <Link to={`/service/` + service.node.slug}>
                            {service.node.title}
                          </Link>
                        </h3>
                        <p>{service.node.excerpt.excerpt}</p>

                        <Link
                          to={`/service/` + service.node.slug}
                          className="read-more-btn"
                        >
                          Read More <i className="flaticon-right"></i>
                        </Link>
                      </div>
                    </div>
                  )
                } else {
                  return null
                }
              })}
          </div>
        </div>
      </section>
    )
  } else {
    return null
  }
}

export default RelatedServices
